<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="owners">
      <div class="row">
        @for (owner of owners.controls; track owner; let index = $index) {
          <ng-container [formGroup]="owner">
            <div class="col-md-{{ owners?.length > 1 ? 6 : 12 }}">
              <owner-header [owners]="owners" [index]="index"></owner-header>
              <ng-container formGroupName="profilEmprunteur">
                <ng-container>
                  <div class="formControl mt">
                    <div class="row d-flex align-items-center">
                      <div class="col col-md-6">
                        <question-description
                          titleDir="left"
                          subTitleDir="left"
                          title="Est-ce que vous souhaitez souscrire à une assurance invalidité professionnelle et perte de revenus ?"
                          [titleStyle]="{ fontSize: '16px' }"
                        >
                        </question-description>
                      </div>
                      <div class="col col-md-6 clear-m">
                        <pr-input-radio
                          formControlName="optionIPP"
                          direction="column"
                          [isDefault]="false"
                          [toggle]="true"
                        >
                        </pr-input-radio>
                      </div>
                    </div>
                  </div>
                  <div class="formControl mt">
                    <div class="row d-flex align-items-center">
                      <div class="col col-md-6">
                        <question-description
                          titleDir="left"
                          subTitleDir="left"
                          title="Est-ce que vous souhaitez souscrire à une assurance dos et psychique ?"
                          [titleStyle]="{ fontSize: '16px' }"
                        >
                        </question-description>
                      </div>
                      <div class="col col-md-6 clear-m">
                        <pr-input-radio
                          formControlName="optionDosPsy"
                          direction="column"
                          [isDefault]="false"
                          [toggle]="true"
                        >
                        </pr-input-radio>
                      </div>
                    </div>
                  </div>
                  <div class="formControl mt">
                    <div class="row d-flex align-items-center">
                      <div class="col col-md-6">
                        <question-description
                          titleDir="left"
                          subTitleDir="left"
                          title="Êtes-vous déjà couvert sur un ou plusieurs prêts immobiliers pour un montant supérieur ou égal à 200 000€ ?"
                          [titleStyle]="{ fontSize: '16px' }"
                        >
                        </question-description>
                      </div>
                      <div class="col col-md-6 clear-m">
                        <pr-input-radio
                          formControlName="loiLemoine"
                          direction="column"
                          [isDefault]="false"
                          [toggle]="true"
                        >
                        </pr-input-radio>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </ng-container>
        }
      </div>
    </ng-container>
  </form-wrapper>
  <form-footer [form]="form" (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
